type PasswordRequirements = {
    length: boolean;
    lowercase: boolean;
    uppercase: boolean;
    number: boolean;
    special: boolean;
};

export const checkPassword = (password: string): {
    valid: boolean;
    requirementsValidation: PasswordRequirements;
} => {
    let valid = false;
    const requirements = {
        length: false,
        lowercase: false,
        uppercase: false,
        number: false,
        special: false,
    };

    if (password.length > 8) {
       requirements.length = true;
    }
    if (/.*[a-z].*/.test(password)) {
        requirements.lowercase = true;
    }
    if (/.*[A-Z].*/.test(password)) {
        requirements.uppercase = true;
    }
    if (/.*[0-9].*/.test(password)) {
        requirements.number = true;
    }
    if (/.*[^a-zA-Z0-9].*/.test(password)) {
        requirements.special = true;
    }

    if (Object.values(requirements).every((value) => value)) {
        valid = true;
    }

    return {
        valid,
        requirementsValidation: requirements,
    }

}